/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Hidden from "@material-ui/core/Hidden";
import { connect } from "react-redux";
import GridList from "../collection/GridList";
import CardDayWiseList from "./CardDayWiseList";
import CardVehicleWiseList from "./CardVehicleWiseList";
import { PageWrapper } from "../../../shared/layout";
import { BarLoader } from "../../../shared/widgets";
import { templateStrings } from "../../../Constant";
import "./cardCollection.css";
import { cardCollectionSummaryAction } from "../../../redux/action-creators/cardCollectionActionCreator";
import { selectDateFilter } from "../../../redux/actions/dateFilterAction";
import { CityWiseId, roles } from "../../../lib/constants";
import ButtonToolbarRangePicker from "../../../shared/components/commonComponents/ButtonToolbarRangePicker";
import HiddenSearchBar from "../../../shared/components/commonComponents/HiddenSearchBar";
import CollectionTabs from "../../../shared/components/commonComponents/CollectionTabs";
import HiddenRangePicker from "../../../shared/components/commonComponents/HiddenRangePicker";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  grid: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  tab: {
    marginLeft: theme.spacing(4),
  },
  picker: {
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "-15px",
    display: "flex",
  },
  title: {
    flexGrow: 1,
  },
}));

function CardCollection(props) {
  const {
    fetchCardCollectionSummary, operatorFilter, cityFilter, selectedDateFilter, content, user,
  } = props;
  const classes = useStyles();
  const [value, setValue] = React.useState("vehicle");
  const [searchString, setSearchString] = React.useState("");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  React.useEffect(() => {
    fetchCardCollectionSummary({
      operatorFilter,
      cityFilter,
      dateFilter: selectedDateFilter,
    });
  }, []);

  React.useEffect(() => {
    fetchCardCollectionSummary({
      operatorFilter,
      cityFilter,
      dateFilter: selectedDateFilter,
    });
  }, [operatorFilter, cityFilter, selectedDateFilter]);

  const handleSearchChange = (e) => {
    setSearchString(e);
  };

  const handleDatesChange = (dates) => {
    if (dates.startDate && dates.endDate) {
      const fromDate = parseFloat(new Date(dates.startDate).getTime());
      const toDate = parseFloat(new Date(dates.endDate).getTime());
      selectDateFilter({ fromDate, toDate });
    }
  };

  const gridItems = content;

  let gridStrings = templateStrings.cardCollectionGridItems;

  if (
    user?.cityIds?.includes(CityWiseId.Mumbai)
    && user.role === roles.agencyManager
  ) {
    gridStrings = JSON.parse(JSON.stringify(gridStrings));
    delete gridStrings.averageBuses;
  }

  return (
    <div className={classes.root}>
      <PageWrapper>
        <HiddenRangePicker
          handleDatesChange={handleDatesChange}
          fromDate={selectedDateFilter.fromDate}
          toDate={selectedDateFilter.toDate}
          pickerClasses={classes.picker}
        />
        <PageWrapper.Header
          heading="Balance Spent"
          showBackArrow
          hideS
        >
          <Hidden only={["sm", "xs"]}>
            <div className="pull-right">
              <ButtonToolbarRangePicker
                handleDatesChange={handleDatesChange}
                fromDate={selectedDateFilter.fromDate}
                toDate={selectedDateFilter.toDate}
              />
            </div>
          </Hidden>
        </PageWrapper.Header>
        <div className="custom-grid-layout">
          {Object.keys(gridStrings).map((column, index) => (
            <div key={index} className="custom-grid">
              <GridList
                value={gridItems[column]}
                template={column}
                type="cardCollectionGridItems"
              />
            </div>
          ))}
        </div>
        <div>
          <PageWrapper.Header hideS>
            <div className="dataTables_length tabWrapper">
              <CollectionTabs value={value} handleChange={handleChange} />
            </div>
            <HiddenSearchBar
              value={value}
              check="vehicle"
              placeHolder="Search Vehicle"
              handleSearchChange={handleSearchChange}
              hiddenFor={["lg", "xl", "md"]}
              classes="tabWrapper"
            />
            <HiddenSearchBar
              value={value}
              check="vehicle"
              placeHolder="Search Vehicle"
              handleSearchChange={handleSearchChange}
              hiddenFor={["sm", "xs"]}
              classes="pull-right search-container"
            />
          </PageWrapper.Header>
        </div>
        <BarLoader scope="header" />
        {value === "vehicle" ? (
          <CardVehicleWiseList searchString={searchString} />
        ) : (
          <CardDayWiseList />
        )}
      </PageWrapper>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    content:
      state
      && state.CardCollection
      && state.CardCollection.cardCollectionSummary,
    cityFilter: state.Cities.selectedCity,
    operatorFilter: state.Operators.selectedOperator,
    selectedDateFilter: state.DateFilter.selectedDateFilter,
    user: state && state.Auth && state.Auth.user,
  };
}

const mapDispatchToProps = (dispatch) => ({
  fetchCardCollectionSummary: (params) => {
    dispatch(cardCollectionSummaryAction(params));
  },
  selectDateFilter: (value) => {
    dispatch(selectDateFilter(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CardCollection);
